module.exports = __webpack_public_path__ + "assets/c0d416ce26487babc0b4460d0dadf899.mp4";